module.exports = __webpack_public_path__ + "static/media/trade-bg.faf79e0d.png";